module.exports = __webpack_public_path__ + "872bdd27f9a248441132115e59d508ec.mp4";